import Image, { ImageProps } from 'next/image'
import { useCallback, useState } from 'react'

type ImageWithFallbackProps = Omit<ImageProps, 'src'> & {
  src: string
}

const ImageWithFallback = ({ src, alt, ...props }: ImageWithFallbackProps) => {
  const [error, setError] = useState(false)

  const handleError = useCallback(() => {
    setError(true)
  }, [])

  return (
    <Image
      src={error ? '/v2/images/brands/placeholder-logo.svg' : src}
      alt={alt}
      onError={handleError}
      {...props}
    />
  )
}

export default ImageWithFallback
